import { useMemo } from 'react';

import { STATE_AGENCIES } from '../../data/stateAgencies';
import type { AgencyRow } from './types';

export function useAgencyGroups(localAgencies: AgencyRow[]) {
  return useMemo(() => {
    const federal: AgencyRow[] = [];
    const state: AgencyRow[] = [];
    const byState: Record<string, AgencyRow[]> = {};

    localAgencies.forEach((agency) => {
      if (agency.code.includes('-')) {
        state.push(agency);
        const stateCode = agency.code.split('-')[1];
        if (!byState[stateCode]) {
          byState[stateCode] = [];
        }
        byState[stateCode].push(agency);
      } else {
        federal.push(agency);
      }
    });

    Object.keys(STATE_AGENCIES).forEach((stateCode) => {
      STATE_AGENCIES[stateCode].forEach((configAgency) => {
        const existsInBackend = localAgencies.some((a) => a.code === configAgency.code);
        if (existsInBackend) return;

        const virtualAgency: AgencyRow = {
          id: configAgency.code,
          name: configAgency.fullName,
          code: configAgency.code,
          isMonitored: false,
          totalLegislations: 0,
        };

        state.push(virtualAgency);
        if (!byState[stateCode]) {
          byState[stateCode] = [];
        }
        byState[stateCode].push(virtualAgency);
      });
    });

    Object.keys(byState).forEach((stateCode) => {
      byState[stateCode].sort((a, b) => a.name.localeCompare(b.name));
    });

    return {
      federalAgencies: federal,
      stateAgencies: state,
      stateAgenciesByState: byState,
    };
  }, [localAgencies]);
}
